<template>
	<div id="bar-row">
		<div v-if="date !== calendarDate && date !== currentDate" style="margin-bottom: 2px">{{ day }}</div>
		<v-btn v-if="date === currentDate" fab depressed width="24" height="24" :color="color" class="white--text" style="margin-bottom: 1px">{{ day }}</v-btn>
		<v-btn v-if="date !== currentDate && date === calendarDate" fab depressed width="24" height="24" :color="color" class="white--text" style="margin-bottom: 1px; opacity: 0.5;">{{ day }}</v-btn>
		<v-row
			v-if="progressByDate && assignedTo.length === 1"
			class="ma-0"
			:align="`end`"
			style="border-radius: 0;"
		>
			<div v-for="(progress, i) in progressByDate[date]" :key="`${i}_${progress.key}`">
				<v-tooltip v-if="progress.percent !== 0" :key="`${i}_${progress.percent}`" bottom color="#FFFFFF">
					<template v-slot:activator="{ on, attrs }">
						<v-badge
							v-if="progress.over" 
							style="cursor: default"
							color="error"
							icon="mdi-exclamation-thick"
							offset-y="8"
							offset-x="20"
							overlap
						>
							<v-btn
								v-bind="attrs"
								v-on="on"
								:style="{margin: marginStyle(i, progressByDate[date].length), opacity: opacityStyle(date)}"
								:min-width="getCurrentWidth(progress.percent, i, progressByDate[date].length)"
								:color="progress.color"
								height="12"
								depressed
							></v-btn>
						</v-badge>
						<v-btn
							v-if="!progress.over" 
							v-bind="attrs"
							v-on="on"
							:style="{margin: marginStyle(i, progressByDate[date].length), opacity: opacityStyle(date)}"
							:min-width="getCurrentWidth(progress.percent, i, progressByDate[date].length)"
							:color="progress.color"
							height="12"
							depressed
						></v-btn>
					</template>
					<div style="width: 180px">
						<v-row justify="space-between" class="capacity-text ma-0" :style="`color: ${progress.text_color}`">
							<div class="text-capitalize" style="opacity: 0.7">{{ progress.key }} 
								<span v-if="progress.key !== 'UNAVAILABLE'">:</span>
							</div>
							<div>{{ progress.hour.budget }}</div>
						</v-row>
						<v-row v-if="progress.hour.over.length !== 0" class="ma-0">
							<v-icon small color="error">mdi-alert-circle</v-icon>
							<span class="capacity-text ml-1" style="color: #F45252">{{ progress.hour.over }} over capacity</span>
						</v-row>
					</div>
				</v-tooltip>
			</div>
		</v-row>
	</div>
</template>

<script>
export default {
	name: 'CalendarCapacityBar',
	props: {
		date: {
			type: String,
			default: ''
		},
		day: {
			type: Number,
			default: 0
		},
		calendarDate: {
			type: String,
			default: ''
		},
		currentDate: {
			type: String,
			default: ''
		},
		progressByDate: {
			type: Object,
			default: () => {}
		},
		assignedTo: {
			type: Array,
			default: () => []
		},
		color: {
			type: String,
			default: ''
		},
		colors: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			elem: null,
		}
	},
	mounted() {
		this.getElement();
	},
	methods: {
		getElement() {
			this.elem = document.getElementById("bar-row");
		},
		marginStyle(index, total_index) {
			let margin_style = '0 2px 6px 2px';

			/** the first element */
			if (index === 0 && total_index !== 1) {
				margin_style = '0 2px 6px 0';
			}
			/** only one element */
			if (index === 0 && total_index === 1) {
				margin_style = '0 2px 6px 2px';
			}
			/** the last element */
			if (index !== 0 && index === (total_index - 1)) {
				margin_style = '0 0 6px 2px';
			}

			return margin_style;
		},
		opacityStyle(date) {
			let opacity_style = 1.0;

			if (date < this.currentDate) {
				opacity_style = 0.5;
			}

			return opacity_style;
		},
		getCurrentWidth(percent, index, total_index) {
			let current_width = 0;

			let current_elem = document.getElementById("bar-row");
			current_elem = current_elem ? current_elem : this.elem;

			if (current_elem) {
				current_width = Math.floor(current_elem.clientWidth * percent * 0.01) ;
			
				if (index === 0 && total_index !== 1) {
					/** the first element */
					current_width = current_width - 2;
				} else if (index !== 0 && index === (total_index - 1)) {
					/** the last element */
					current_width = current_width - 2;
				} else {
					current_width = current_width - 4;
				}
			}

			return current_width;
		}
	}
}
</script>
<style lang="scss" scoped>
.capacity-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #192A3E;
}
</style>